export default __webpack_public_path__ + "static/media/right-side-banner-image.a216d7c2.svg";